// extracted by mini-css-extract-plugin
export var content = "content__JPzmm";
export var icon = "icon__azbT1";
export var closeButton = "close-button__We3LH";